<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DevOps',
  data () {
    return {
      cards: [{
        title: 'devops.kubernetes.title',
        img: {link: 'static/img/kubernetes.png', alt: 'devops.kubernetes.alt.pict'},
        desc: 'devops.kubernetes.desc',
        action: 'devops.kubernetes.action'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DevOps.vue